import { createSelector } from 'reselect';
import pathsManifest from 'app/shared/pathsManifest';
import UserSelectors from './UserSelectors';

const paths = pathsManifest.getAllPaths();

const getUserManagement = state => state.userManagement;

const getRouting = state => state.router;

const getLocation = state => getRouting(state).location;

const getCompanyUsers = state => state.userManagement.companyUsers.users;

const TabList = {
    users: 'users',
    pending: 'pending',
};

const UserManagementSelectors = {
    makeCompany: createSelector([getUserManagement], userManagement => userManagement.company),
    makeCompanyUsers: createSelector([getUserManagement], userManagement => userManagement.companyUsers),
    makeCurrentUser: createSelector([getUserManagement], userManagement => userManagement.currentUser),
    makeEditableProperties: createSelector([getUserManagement], userManagement => userManagement.editableProperties),
    makeEditableUser: createSelector([getUserManagement], userManagement => userManagement.editableUser),
    makeActiveTab: createSelector([getLocation], (location) => {
        const tabName = location.pathname.split('/')[3];

        switch (tabName) {
            case paths.userManagementUsers:
                return paths.userManagementUsers;
            case paths.userManagementActivity:
                return paths.userManagementActivity;
            case paths.userManagementPending:
                return paths.userManagementPending;
            case paths.userManagementUnrecognizedUsers:
                return paths.userManagementUnrecognizedUsers;
            default:
                return paths.userManagementUsers;
        }
    }),
};

UserManagementSelectors.makeUserList =
    createSelector(
        [getCompanyUsers, UserManagementSelectors.makeActiveTab, UserSelectors.makeUser],
        (users, activeTab, user) => {
            const isPending = activeTab === TabList.pending;
            const sortedUsers = users.filter(companyUser => companyUser.isPending === isPending);
            sortedUsers.sort((a, b) => {
                if (a.userToken === user.userToken) {
                    return -1;
                }
                if (b.userToken === user.userToken) {
                    return 1;
                }
                return a.userName.localeCompare(b.userName);
            });
            return sortedUsers;
        }
    );

export default UserManagementSelectors;
